import '../scss/reviews.scss';

// Scorecard scroll reveal: progress-bar scores fill and count up the first time
// they enter the viewport. The card is only armed (bars emptied) once the
// script runs, so a blocked script or reduced motion leaves it as rendered.
const DURATION = 1200;

const countUp = (el) => {
	const text = el.textContent.trim();
	const target = Number.parseFloat(text);
	if (!Number.isFinite(target) || !/^\d+(\.\d+)?$/.test(text)) {
		return;
	}
	const decimals = (text.split('.')[1] || '').length;
	const start = performance.now();
	const step = (now) => {
		const t = Math.min(1, (now - start) / DURATION);
		const eased = 1 - (1 - t) ** 3;
		el.textContent = (target * eased).toFixed(decimals);
		if (t < 1) {
			requestAnimationFrame(step);
		} else {
			el.textContent = text;
		}
	};
	el.textContent = (0).toFixed(decimals);
	requestAnimationFrame(step);
};

const init = () => {
	const cards = document.querySelectorAll('.jkd-review-scorecard[data-jkdrev-reveal]');
	if (!cards.length || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		return;
	}

	// One score at a time: the card is tall, so its lower criteria reveal when
	// they reach the screen, not when the card's top does.
	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return;
			}
			observer.unobserve(entry.target);
			entry.target.classList.add('is-revealed');
			entry.target.querySelectorAll('.jkd-review__score-primary').forEach(countUp);
		});
	}, {threshold: 0.6});

	cards.forEach((card) => {
		card.classList.add('is-armed');
		card.querySelectorAll('.jkd-review--mode-gradient-bar').forEach((score) => observer.observe(score));
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
